import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController,AlertController } from 'ionic-angular';
import { Http } from '@angular/http';
import config from "../../../config/config";

/**
 * Generated class for the CadastroAgendaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-cadastro-agenda',
  templateUrl: 'eccadastro-agenda.html',
})
export class ecCadastroAgendaPage {
  servicos = [];
  operarios: any[];
  responsaveis = [];
  servicoescolhido: any;
  novoServico:any;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public _http: Http,
    private alertCtrl: AlertController,
  ) {
  }

  ionViewDidLoad() {
    this.getServico()
    this.getOperadores()
  }
  getServico() {
    this._http
      .get(config.urlAPI + "pesquisar/servicoCultural", {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.servicos = res;
      })
      .catch(error => { });
  }
  getOperadores() {
    this._http
      .get(config.urlAPI + "usuario/operadores", {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.operarios = res;
        this.operarios.map((r, i) => {
          this.operarios[i].checked = false
        })
      })
      .catch(error => {
      });
  }
  adicionarResponsavel(env) {
    if (this.responsaveis.indexOf(env) != -1) {
      this.responsaveis.splice(this.responsaveis.indexOf(env), 1)
    } else {
      this.responsaveis.push(env)
    }
  }
  buscarResponsavel(env) {
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    this._http
      .get(config.urlAPI + "pesquisar/responsavelEspacocultural/" + env, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.operarios.map(u => {        
            u.checked = false          
        })
        res.map((r) => {  
        this.operarios.map(u => {
            if (u.id == r.id_funcionario) {
              u.checked = true
            } 
          })
        })
        loading.dismiss();
      })
      .catch(error => {
      });

  }
  salvar() {
    if (this.servicoescolhido == null || this.servicoescolhido == undefined) {
      let alert = this.alertCtrl.create({
        title: "Por favor",
        subTitle: "Escolha um Serviço",
        buttons: [
          {
            text: "OK",
            handler: data => {
            }
          }
        ],
      enableBackdropDismiss: false

      });
      alert.present();

      return true
    }
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
   let env = {
      servico:this.servicoescolhido,
      responsaveis:this.responsaveis
    }
    this.funcaoDeletar(env).then((r)=>{
      this.funcaoSalvar(env).then((e)=>{
          loading.dismiss();
          let alert = this.alertCtrl.create({
            title: "Sucesso",
            subTitle: "Serviço salvo com os seus respectivos Responsáveis",
            buttons: [
              {
                text: "OK",
                handler: data => {
                  this.servicoescolhido = null;
                  this.responsaveis = [];
                  this.ionViewDidLoad()
                }
              }
            ],
          enableBackdropDismiss: false

          });
          alert.present();
      }).catch((err)=>{
        let alert = this.alertCtrl.create({
          title: "Erro",
          subTitle: "Ocorreu um erro ao Salvar",
          buttons: [
            {
              text: "OK",
              handler: data => {
                this.servicoescolhido = null;
                this.responsaveis = [];
                this.ionViewDidLoad()
              }
            }
          ],
          enableBackdropDismiss: false

        });
        alert.present();
        loading.dismiss();

      })
    }).catch((err)=>{
      let alert = this.alertCtrl.create({
        title: "Erro",
        subTitle: "Ocorreu um erro ao Deletar",
        buttons: [
          {
            text: "OK",
            handler: data => {
              this.servicoescolhido = null;
              this.responsaveis = [];
              this.ionViewDidLoad()
            }
          }
        ]
      });
      alert.present();
      loading.dismiss();
    })

  }
  async funcaoDeletar(env){
    this._http
    .post(config.urlAPI + "servico/responsaveisEspacocultural/deletar",env, {})
    .map(res => res.json())
    .toPromise()
    .then(res => {
      return res;      
    })
    .catch(err => {
      console.log(err)
    });
  }
  async funcaoSalvar(env){
    this._http
    .post(config.urlAPI + "servico/responsaveisEspacocultural",env, {})
    .map(res => res.json())
    .toPromise()
    .then(res => {
      return res
    })
    .catch(err => {
      console.log(err)
    });
  }
  cadastrarNovo(){
    if (this.novoServico == undefined || this.novoServico == null || this.novoServico == ""||this.novoServico == " " ) {
      return true
    }
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    let env = {
      novo:this.novoServico,
    }
    this._http
    .post(config.urlAPI + "servicoCultural/novo",env, {})
    .map(res => res.json())
    .toPromise()
    .then(res => {
      loading.dismiss()
      let alert = this.alertCtrl.create({
        title: "Sucesso",
        subTitle: "Novo serviço cadastrado",
        buttons: [
          {
            text: "OK",
            handler: data => {
              this.servicoescolhido = null;
              this.responsaveis = [];
              this.novoServico = null;
              this.ionViewDidLoad()
            }
          }
        ],
        enableBackdropDismiss: false

      });
      alert.present();
    })
    .catch(err => {
      console.log(err)
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/espaco-cultural/cadastro-agenda/eccadastro-agenda.ts